export default __webpack_public_path__ + "static/media/Preloader.b78ac513.gif";